var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8889 14.3889H15.4444C15.857 14.3889 16.2527 14.225 16.5444 13.9333C16.8361 13.6416 17 13.2459 17 12.8333V9.72222C17 9.30966 16.8361 8.914 16.5444 8.62228C16.2527 8.33056 15.857 8.16667 15.4444 8.16667H4.55556C4.143 8.16667 3.74733 8.33056 3.45561 8.62228C3.16389 8.914 3 9.30966 3 9.72222V12.8333C3 13.2459 3.16389 13.6416 3.45561 13.9333C3.74733 14.225 4.143 14.3889 4.55556 14.3889H6.11111M13.8889 8.16667V5.05556C13.8889 4.643 13.725 4.24733 13.4333 3.95561C13.1416 3.66389 12.7459 3.5 12.3333 3.5H7.66667C7.25411 3.5 6.85845 3.66389 6.56672 3.95561C6.275 4.24733 6.11111 4.643 6.11111 5.05556V8.16667M6.11111 12.8333C6.11111 12.4208 6.275 12.0251 6.56672 11.7334C6.85845 11.4417 7.25411 11.2778 7.66667 11.2778H12.3333C12.7459 11.2778 13.1416 11.4417 13.4333 11.7334C13.725 12.0251 13.8889 12.4208 13.8889 12.8333V15.9444C13.8889 16.357 13.725 16.7527 13.4333 17.0444C13.1416 17.3361 12.7459 17.5 12.3333 17.5H7.66667C7.25411 17.5 6.85845 17.3361 6.56672 17.0444C6.275 16.7527 6.11111 16.357 6.11111 15.9444V12.8333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPrinterIcon);
export default __webpack_public_path__ + "static/media/menu-printer-icon.b9c85f4f38bd04836be35e61f7c6a188.svg";
export { ForwardRef as ReactComponent };